export default __webpack_public_path__ + "247557bce792107cdfc42f7cea54addd.png";